class AddUsers {
  construction() {
    this.FirstName = '';
    this.LastName = '';
    this.EmailAddr = '';
    this.MiddleName = '';
    this.ConfirmEmailAddr = '';
    this.TempPassword = '';
  }

  getFirstName() {
    return this.FirstName;
  }

  setFirstName(FirstName) {
    this.FirstName = FirstName;
  }

  getMiddleName() {
    return this.MiddleName;
  }

  setMiddleName(MiddleName) {
    this.MiddleName = MiddleName;
  }

  getLastName() {
    return this.LastName;
  }

  setLastName(LastName) {
    this.LastName = LastName;
  }

  getEmailAddr() {
    return this.EmailAddr;
  }

  setEmailAddr(EmailAddr) {
    this.EmailAddr = EmailAddr;
  }

  getConfirmEmailAddr() {
    return this.ConfirmEmailAddr;
  }

  setConfirmEmailAddr(ConfirmEmailAddr) {
    this.ConfirmEmailAddr = ConfirmEmailAddr;
  }

  getTempPassword() {
    return this.Password;
  }

  setTempPassword(Password) {
    this.Password = Password;
  }

  getSubmitStatus() {
    return this.submitStatus;
  }

  setSubmitStatus(submitStatus) {
    this.submitStatus = submitStatus;
  }

  resetAddUers() {
    this.FirstName = '';
    this.LastName = '';
    this.EmailAddr = '';
    this.MiddleName = '';
    this.ConfirmEmailAddr = '';
    this.TempPassword = '';
  }
}
export default new AddUsers();
